<template>
    <div>

        <div class="row">
            <div class="col-md-4">
                <span class="section--title">Stock Overview
                    <span>
                        <toggle-button 
                            v-model="selected.yesterday"
                            :width="100"
                            :height="25"
                            color="#7dCE94" 
                            :sync="true" 
                            :labels="{checked: 'H-1', unchecked: 'Real Time'}"
                        />
                    </span>
                </span>
            </div>
            <div class="col-md-8">
                <div class="row">
                    <div class="col-6 col-md-3">
                        <Multiselect 
                            :options="options.stockOverviewStats.dealer.map(x => x.code)"
                            :custom-label="opt => options.stockOverviewStats.dealer.find(x => x.code == opt).name"
                            placeholder="All Dealer"
                            v-model="selected.stockOverviewStats.dealer" 
                        />
                    </div>
                    <div class="col-6 col-md-3">                        
                        <Multiselect 
                            :options="options.stockOverviewStats.segment.map(x => x.segment)"
                            placeholder="All Segment"
                            v-model="selected.stockOverviewStats.segment" 
                        />
                    </div>
                    <div class="col-6 col-md-3">                        
                        <Multiselect 
                            :options="options.stockOverviewStats.type.map(x => x.type)"
                            placeholder="All Type"
                            v-model="selected.stockOverviewStats.type" 
                        />
                    </div>
                    <div class="col-6 col-md-3">                        
                        <Multiselect 
                            :options="options.stockOverviewStats.color.map(x => x.color)"
                            :custom-label="opt => options.stockOverviewStats.color.find(x => x.color == opt).name"
                            placeholder="All Color"
                            v-model="selected.stockOverviewStats.color" 
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-2 mb-2">
            <div class="col-6 col-md-2 offset-md-10 offset-6">
                <button
                    class="btn btn-dh-download"
                    @click="exportCsvStats()"
                >Download CSV&nbsp;&nbsp;<i class="fas fa-download"></i></button>
            </div>
        </div>

        <!-- Stats Start -->
        <stats
            :data="data.stockOverviewStats"
            :data_do="data.stockOverviewDoPending"
        ></stats>
        <!-- Stats End -->

        <div class="dh--divider"></div>

        <!-- Detail Stock Overview Start -->
        <div class="row">
            <div class="col-md-4">
                <span class="section--title">Detail Stock Overview</span>
            </div>
            <div class="col-md-8">
                <div class="row">
                    <div class="col-6 col-md">                        
                        <Multiselect 
                            :options="options.stockOverviewDetails.dealer.map(x => x.code)"
                            :custom-label="opt => options.stockOverviewDetails.dealer.find(x => x.code == opt).name"
                            placeholder="All Dealer"
                            v-model="filter.stockOverviewDetails.dealer"
                        />
                    </div>
                    <div class="col-6 col-md">                        
                        <Multiselect 
                            :options="options.stockOverviewDetails.segment.map(x => x.segment)"
                            placeholder="All Segment"
                            v-model="filter.stockOverviewDetails.segment" 
                        />
                    </div>
                    <div class="col-6 col-md">                        
                        <Multiselect 
                            :options="options.stockOverviewDetails.type.map(x => x.type)"
                            placeholder="All Type"
                            v-model="filter.stockOverviewDetails.type" 
                        />
                    </div>
                    <div class="col-6 col-md">                        
                        <Multiselect 
                            :options="options.stockOverviewDetails.color.map(x => x.color)"
                            :custom-label="opt => options.stockOverviewDetails.color.find(x => x.color == opt).name"
                            placeholder="All Color"
                            v-model="filter.stockOverviewDetails.color" 
                        />
                    </div>
                    <div class="col-6 col-md">
                        <button
                            class="btn btn-dh-download"
                            @click="exportCsv(data.stockOverviewDetails, 'Detail Stock Overview (' + moment().format('DD MMM YYYY') + ')')"
                        >Download CSV&nbsp;&nbsp;<i class="fas fa-download"></i></button>
                    </div>
                </div>
            </div>
        </div>

        <detail-table
            v-if="data.stockOverviewDetails"
            :data="data.stockOverviewDetails"
            :filter="filter.stockOverviewDetails"
        ></detail-table>
        <div style="min-height: 300px; display: flex; align-items: center; justify-content: center;" v-else>
            <div>
                <fold :loading="true"></fold>
                <p style="margin: 0; font-size: 40px; text-shadow: 2px 2px 2px grey">Loading...</p>
            </div>
        </div>
        <!-- Detail Stock Overview End -->

    </div>
</template>

<script>
    import moment from 'moment'
    import Multiselect from 'vue-multiselect'
    import { FoldSpinner } from 'vue-spinners'
    import { ToggleButton } from 'vue-js-toggle-button'
    const XLSX = require('xlsx')

    import stats from './children/dealerHighlightStats'
    import detailTable from './children/detailStockOverviewTable'

    export default {
        data () {
            return {
                moment : moment,
                options : {
                    stockOverviewStats : {
                        segment : this.$store.getters.getSimpleSegment(),
                        type : this.$store.getters.getSimpleType(),
                        color : this.$store.getters.getColor,
                        dealer : this.$store.getters.getDealer()
                    },
                    stockOverviewDetails : {
                        segment : this.$store.getters.getSimpleSegment(),
                        type : this.$store.getters.getSimpleType(),
                        color : this.$store.getters.getColor,
                        dealer : this.$store.getters.getDealer()
                    }
                },
                selected : {
                    // yesterday : false,
                    yesterday : true,
                    
                    //stockOverviewStats and stockOverviewDoPending
                    stockOverviewStats : {
                        segment : null,
                        type : null,
                        color : null,
                        dealer : null
                    },
                },
            }
        },
        props : ['filter', 'data'],
        components : {
            Multiselect,
		    ToggleButton,
            fold : FoldSpinner,
            
            stats,
            detailTable
        },
        computed : {
            stockOverviewStatsSegment () {return this.selected.stockOverviewStats.segment},
            stockOverviewDetailsSegment () {return this.filter.stockOverviewDetails.segment},
        },
        watch : {
            stockOverviewStatsSegment () {
                this.options.stockOverviewStats.type = this.$store.getters.getSimpleType(null, this.selected.stockOverviewStats.segment, null);
                this.selected.stockOverviewStats.type = null;
            },
            stockOverviewDetailsSegment () {
                this.options.stockOverviewDetails.type = this.$store.getters.getSimpleType(null, this.filter.stockOverviewDetails.segment, null);
                this.filter.stockOverviewDetails.type = null;
            },
            'selected.yesterday' () {
                let date = (this.selected.yesterday) ? moment().subtract(1,'days') : moment();
                date = date.format("YYYY-MM-DD");

                for (var i in this.filter) this.filter[i].period = date;
            },
            'selected.stockOverviewStats' : {
                deep : true,
                handler () {
                    for (var i in this.selected.stockOverviewStats) {
                        this.filter.stockOverviewStats[i] = this.selected.stockOverviewStats[i];
                        this.filter.stockOverviewDoPending[i] = this.selected.stockOverviewStats[i];
                    }
                }
            }
        },
        mounted () {

        },
        methods : {
            async exportCsvStats() {
                try {
                    let urlAPI = '/api/highlight-dealer/stock-overview/download?'
                    urlAPI = this.initialiseFilter(urlAPI , this.filter.stockOverviewStats)

                    let response = await this.$http({
                        responseType: 'blob',
                        url : urlAPI,
                        method : 'get'
                    })

                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Dealer Stats.xlsx'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                }
                catch (err) {
                    console.log(err)
                    this.$swal({
                        icon : 'error',
                        text: 'Something went wrong!',
                        footer : err
                    })
                }
            }
        }
    }
</script>

<style scoped>

</style>